import {
	getAssetFields,
	getAssetFieldsRejected,
	getAssetFieldsResolved,
	getAssetFilterList,
	getAssetFilterListRejected,
	getAssetFilterListResolved,
	getSpatialLayerList,
	getSpatialLayerListRejected,
	getSpatialLayerListResolved,
} from '@Actions/asset.actions';
import {
	put,
	retry,
	call,
	throttle,
	takeLatest,
} from '@redux-saga/core/effects';
import { getAssetFilterListApi } from '@Services/asset/asset.services';
import { getSpatialLayerListApi } from '@Services/Risk/Risk.services';
import { AssetFilterListItem } from '@Types/asset.types';
import {
	getAssetSchema,
	AssetSchema,
	GenericSingleProperty,
	NestedProperty,
} from '@innovyze/lib_asset_schema';
import { AxiosResponse } from 'axios';
import { SpatialLayer } from '@innovyze/lib-am-common';
import { AnyAction } from 'redux';

export function* getAssetFieldsSaga(action: AnyAction) {
	try {
		const { systemType, assetType } = action.payload;

		const assetSchema: AssetSchema = yield call(getAssetSchema, {
			systemTypeId: systemType,
			assetTypeId: assetType,
		});
		const properties = assetSchema?.getProperties()?.flatMap(p => {
			return (p as NestedProperty).properties ?? p;
		});

		const result = properties?.map(property => {
			const p = property as GenericSingleProperty;
			return {
				name: p.id,
				type: p.type,
				precision: p.precision,
				displayName: p.displayName,
				units: p.units,
			};
		});

		yield put(getAssetFieldsResolved(result));
	} catch (e) {
		yield put(getAssetFieldsRejected());
	}
}
function* watchGetAssetFields() {
	yield takeLatest(getAssetFields, getAssetFieldsSaga);
}

export function* getAssetFilterListSaga() {
	try {
		const payload: AxiosResponse<AssetFilterListItem[]> = yield retry(
			5,
			1500,
			getAssetFilterListApi,
		);

		yield put(getAssetFilterListResolved(payload.data));
	} catch (e) {
		yield put(getAssetFilterListRejected());
	}
}

function* watchGetAssetFilterList() {
	yield throttle(5 * 1000, getAssetFilterList, getAssetFilterListSaga);
}

export function* getSpatialLayerListSaga() {
	try {
		const payload: AxiosResponse<SpatialLayer[]> = yield retry(
			5,
			1500,
			getSpatialLayerListApi,
		);

		yield put(getSpatialLayerListResolved(payload.data));
	} catch (e) {
		yield put(getSpatialLayerListRejected());
	}
}
function* watchGetSpatialLayerList() {
	yield takeLatest(getSpatialLayerList, getSpatialLayerListSaga);
}

const sagaArray = [
	watchGetAssetFields(),
	watchGetAssetFilterList(),
	watchGetSpatialLayerList(),
];

export default sagaArray;
